import makeValidationSchema from './UsedVehicleDetailsMakeValidationSchema'
import { useTranslation } from 'cng-web-lib'
import React from 'react'
import Namespace from 'src/constants/locale/Namespace'
import AesShipmentKeys from 'src/constants/locale/key/AesShipment'
import { Card, CardContent, Grid, Tooltip } from '@material-ui/core'
import {
  components,
} from 'cng-web-lib'
import UsedVehicleDetailsFormProperties from './UsedVehicleDetailsFormProperties'

const {
  button: { CngIconButton }
} = components

const { initialValues } = UsedVehicleDetailsFormProperties.formikProps

function UsedVehicleDetailsEntry({
  index,
  isLast,
  onAddUsedVehicleDetails,
  onDeleteUsedVehicleDetails,
  usedVehicleDetails,
  showNotification
}) {

  return (

    <Grid container spacing={2}>
      <Grid item xs={12} md>
        <UsedVehicleDetailsFormProperties.Fields index={index} showNotification={showNotification} />
      </Grid>
      <Grid item xs={12} md='auto'>
        <Grid container spacing={1}>
          <Grid item xs='auto'>
            <Tooltip placement='bottom' title='Add new'>
              <span>
                <CngIconButton
                  icon={['fal', 'plus']}
                  onClick={() => onAddUsedVehicleDetails(initialValues)}
                  size='small'
                  type='outlined'
                />
              </span>
            </Tooltip>
          </Grid>
          <Grid item xs='auto'>
            <Tooltip placement='bottom' title='Clone'>
              <span>
                <CngIconButton
                  icon={['fal', 'copy']}
                  onClick={() => onAddUsedVehicleDetails({ ...usedVehicleDetails, id: undefined })}
                  size='small'
                  type='outlined'
                />
              </span>
            </Tooltip>
          </Grid>
          {!isLast && (
            <Grid item xs='auto'>
              <Tooltip placement='bottom' title='Delete'>
                <span>
                  <CngIconButton
                    icon={['fal', 'trash']}
                    onClick={() => onDeleteUsedVehicleDetails(usedVehicleDetails)}
                    size='small'
                    type='outlined'
                  />
                </span>
              </Tooltip>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}

export default UsedVehicleDetailsEntry
